var _rect, _rect2, _path, _circle, _path2, _rect3, _g, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRappel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1428,
    transform: "translate(-739 -396)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M701 -396H-739V1032H701V-396Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    r: 10,
    fill: "#44499C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.708 -3.99976L16.4147 0.170244C16.5233 0.291578 16.5833 0.449578 16.5833 0.612911V3.79491L17.4153 3.24024V0.612911C17.4153 0.449578 17.4753 0.291578 17.584 0.170244L21.29 -3.99976H12.708ZM16.2773 5.39475C16.1113 5.39475 15.9446 5.35408 15.7919 5.27275C15.4573 5.09408 15.2499 4.74608 15.2499 4.36675V0.866081L11.2599 -3.62325C10.9906 -3.92525 10.9246 -4.35792 11.0899 -4.72659C11.2559 -5.09525 11.6233 -5.33325 12.0279 -5.33325H21.9706C22.3746 -5.33325 22.7426 -5.09525 22.9086 -4.72659C23.0739 -4.35792 23.0079 -3.92525 22.7393 -3.62325L18.7486 0.866081V3.40341C18.7486 3.74875 18.5773 4.06941 18.2899 4.26008L16.8473 5.22141C16.6753 5.33675 16.4766 5.39475 16.2773 5.39475V5.39475Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -739,
    y: -396,
    width: 1440,
    height: 1428,
    fill: "black",
    fillOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23_3115)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -406,
    y: -270,
    width: 779,
    height: 796,
    rx: 12,
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 12.1524L13.75 11.5899V10.25C13.7486 9.45316 13.4656 8.68246 12.9509 8.07412C12.4363 7.46578 11.7231 7.05898 10.9375 6.92563V5.75H9.8125V6.92563C9.0269 7.05898 8.31373 7.46578 7.79907 8.07412C7.2844 8.68246 7.00137 9.45316 7 10.25V11.5899L5.875 12.1524V14.75H9.25V15.875H11.5V14.75H14.875V12.1524ZM13.75 13.625H7V12.8476L8.125 12.2851V10.25C8.125 9.65326 8.36205 9.08097 8.78401 8.65901C9.20597 8.23705 9.77826 8 10.375 8C10.9717 8 11.544 8.23705 11.966 8.65901C12.3879 9.08097 12.625 9.65326 12.625 10.25V12.2851L13.75 12.8476V13.625Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2.375C13.75 2.07663 13.6315 1.79048 13.4205 1.5795C13.2095 1.36853 12.9234 1.25 12.625 1.25H10.375V0.125H9.25V1.25H4.75V0.125H3.625V1.25H1.375C1.07663 1.25 0.790483 1.36853 0.579505 1.5795C0.368526 1.79048 0.25 2.07663 0.25 2.375V13.625C0.25 13.9234 0.368526 14.2095 0.579505 14.4205C0.790483 14.6315 1.07663 14.75 1.375 14.75H3.625V13.625H1.375V2.375H3.625V3.5H4.75V2.375H9.25V3.5H10.375V2.375H12.625V5.75H13.75V2.375Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23_3115",
    x: -418,
    y: -279,
    width: 803,
    height: 820,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23_3115"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23_3115",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRappel);
export default __webpack_public_path__ + "static/media/rappel.0cdfe58dc6664cab58cb3ed4dd34a663.svg";
export { ForwardRef as ReactComponent };